module.exports = __webpack_public_path__ + "static/img/banner3.765d5f16.png";